module.exports = __webpack_public_path__ + "static/media/Banner-eng-1.c7c8d63e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/best-deals/Banner-eng-1.png
// module id = 2003
// module chunks = 0